export const color = (percentage: number) => {
    if (percentage >= 75) return '#32BDD2';
    if (percentage >= 25) return '#FFC800';
    return '#FA1E64';
}